module.exports = __webpack_public_path__ + "img/krathong_4.650f500c.png";